<template>
  <div>
    <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
      <notifications></notifications>
      <side-bar v-if="!isExternalLink">
        <!--<user-menu></user-menu>-->
        <mobile-menu></mobile-menu>
        <template slot-scope="props" slot="links">
          <!-- Restriccion 84 "solo informe de turnos": el sidebar solo lleva a ese informe -->
          <template v-if="soloTurnos">
            <sidebar-item
              :link="{
                name: $t('turnosOperarios'),
                icon: 'fas fa-user-clock',
                path: '/informes/operarios/turnos-operarios',
              }"
            >
            </sidebar-item>
          </template>
          <template v-else>
          <template v-if="cajaOnline && !esSelfi">
            <sidebar-item
              :link="{
                name: $t('cajaOnline'),
                icon: 'fa fa-eye',
                path: '/cajas-online',
              }"
            >
            </sidebar-item>
          </template>
          <template v-if="informes && !esSelfi">
            <sidebar-item
              :link="{
                name: $t('informes'),
                icon: 'fa fa-chart-bar',
                path: '/informes',
                isRoute: true,
              }"
            >
            </sidebar-item>
          </template>

          <!-- <a class="nav-link disabled">Disabled</a> -->
          <template v-if="pedidosProveedor && !esSelfi">
            <sidebar-item
              :link="{
                name: $t('pedidosProveedor'),
                icon: 'fas fa-tags',
                path: '/pedidos-proveedor',
              }"
            >
            </sidebar-item>
          </template>
          <template v-if="gastos && !esSelfi">
            <sidebar-item
              :link="{
                name: $t('gastos'),
                icon: 'fa fa-credit-card',
                path: '/gestion-gastos',
              }"
            >
            </sidebar-item>
          </template>
          <template v-if="almacen && !esSelfi">
            <sidebar-item
              :link="{
                name: $t('almacen'),
                icon: 'fas fa-warehouse',
                path: '/almacen',
              }"
            >
            </sidebar-item>
          </template>
          <template v-if="configuracion && !esSelfi">
            <sidebar-item
              :link="{
                name: $t('configuracion'),
                icon: 'fa fa-cogs',
                path: '/configuracion',
              }"
            >
            </sidebar-item>
          </template>
          <template v-if="posicionGlobal && !esSelfi">
            <sidebar-item
              :link="{
                name: $t('posicionGlobal'),
                icon: 'fa fa-globe',
                path: '/posicion-global',
              }"
            >
            </sidebar-item>
          </template>
          <!--
          <sidebar-item
            v-if="camaras"
            :link="{ name: $t('camaras'), icon: 'fas fa-camera', path: '/camaras' }"
          ></sidebar-item>
          -->
          <sidebar-item
            v-if="gestionDePersonal && negocioGestionDePersonal && !esSelfi"
            :link="{
              name: $t('gestionDePersonal'),
              icon: 'fas fa-user-clock',
              path: '/calendar',
            }"
          ></sidebar-item>

          <sidebar-item
            v-if="!esSelfi"
            :link="{
              name: $t('soporteOnline'),
              icon: 'fa fa-envelope',
              path: '/soporte-online',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="configuracionCarta && carta && soloRetail && esSelfi"
            :link="{
              name: $t('configuracionCarta'),
              icon: 'fas fa-cogs',
              path: '/configuracion-carta',
            }"
          ></sidebar-item>
          <!--- Manual de insturcción para los usuarios de Selfibar.-->
          <template>
            <sidebar-item
              v-if="esSelfi"
              :link="{
                name: 'guia-usuario',
                icon: 'fas fa-book',
                text: $t('guiaUsuario')
              }"
            />
        </template>
          <sidebar-item
            v-if="carta && soloRetail && !esSelfi"
            :link="{ name: $t('carta'), icon: 'fas fa-shopping-basket' }"
          >
            <sidebar-item
              v-if="gestionPedidos"
              :link="{
                name: $t('gestionDePedidos'),
                icon: 'fas fa-utensils',
                path: '/delivery',
              }"
            ></sidebar-item>

            <sidebar-item
              v-if="configuracionCarta"
              :link="{
                name: $t('configuracionCarta'),
                icon: 'fas fa-cogs',
                path: '/configuracion-carta',
              }"
            ></sidebar-item>
          </sidebar-item>

          <!--TODO CAMBIAR EL NOMBRE DEL COMPONENTE PARA IMPORTAR LOS EXCELS -->
          <sidebar-item
            v-if="amorino"
            :link="{
              name: $t('importacionExcels'),
              icon: 'far fa-file-excel',
              path: '/importacion',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="integracion"
            :link="{
              name: $t('integraciones'),
              icon: 'fa-solid fa-circle-nodes',
              path: '/integraciones',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="log"
            :link="{
              name: 'LOG',
              icon: 'fa-solid fa-fingerprint',
              path: '/log',
            }"
          >
          </sidebar-item>
          <sidebar-item
            :link="{
              name: 'Verifactu',
              icon: 'fa fa-check',
              path: '/verifactu',
              verifactuStatus: verifactuStatus
        }"
    >
        </sidebar-item>
          </template>
        </template>
      </side-bar>
      <div class="main-panel">
        <top-navbar v-if="!isExternalLink"></top-navbar>

        <dashboard-content @click="toggleSidebar"> </dashboard-content>

        <content-footer></content-footer>
      </div>
    </div>

    <!-- Modal de advertencia Verifactu -->
    <info-modal
      :visible="mostrarModalVerifactu"
      type="info"
      image="verifactu-inicio-2027.png"
      header-text="verifactuProximoTitulo"
      body-text="verifactuProximoMensaje"
      button-text-key="subirCertificadoVerifactu"
      action="goToVerifactu"
      :close-on-backdrop="false"
      :show-secondary-action="true"
      secondary-action-text="cerrarYNoVolverAMostrar"
      @close="cerrarModal"
      @secondary-action="noVolverAMostrarModalVerifactu"
    />
  </div>
</template>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
import UserMenu from "./Extra/UserMenu.vue";
import { Loading } from "element-ui";
import swal from "sweetalert2";

// 0: No mostrar modal
// 1: Mostrar solo una vez cuando cambie la lista de businesses (1 vez, prácticamente o tras F5)
// 2: Mostrar siempre (en rutas principales)
const NIVEL_MOLESTIA_MODAL_VERIFACTU = 0;

export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
    UserMenu,
  },
  created() {
    // Usuario "solo informe de turnos" (restriccion 84): no carga nada del resto del
    // dashboard; la API se lo rechazaria de todos modos. El guard del router ya ha
    // resuelto el modo antes de crear el layout.
    if (this.soloTurnos) {
      this.checkIsSelfi();
      return;
    }

    // this.loading = Loading.service({text: 'Cargando...'});
    //this.getCamaras();
    this.getConfigIntegracion();
    this.restrictions();
    // developerView (config 133) al entrar: lo consultan las pantallas con partes en desarrollo
    this.$store.dispatch("cargarDeveloperView");
    this.checkGestionPersonal();
    this.getConfigTpvRetail();
    this.checkIsSelfi();

    // DEBUG
    if (this.forceMostrarModalVerifactu) {
      this.mostrarModalVerifactu = true;
    }
  },

  data() {
    return {
      gestionDePersonal: true,
      negocioGestionDePersonal: false,
      loading: null,

      camaras: true,

      cajaOnline: true,
      informes: true,
      gastos: true,
      almacen: true,
      pedidosProveedor: true,
      configuracion: true,
      posicionGlobal: true,

      // Modal Verifactu
      mostrarModalVerifactu: false,
      modalVerifactuMostrado: false,
      timeoutModalVerifactu: null,

      // DEBUG MODAL PARA PRUEBAS
      forceMostrarModalVerifactu: false,

      //PERMISOS CONFIGURACION

      materiaPrima: true,
      proveedores: true,
      etiquetas: true,
      productos: true,
      categorias: true,
      modificadores: true,
      clientes: true,
      casas: true,
      operarios: true,
      agencias: true,
      formasPago: true,
      configuracionAlmacen: true,
      rangosHorarios: true,

      //PERMISOS INFORMES

      ventasProductos: true,
      ventasTotalProductos: true,
      invitaciones: true,
      ventasCategorias: true,
      costeProductos: true,
      historicoProductos: true,

      gastosCasas: true,
      gastosCasa: true,

      gastosProveedoresUnidos: true,
      gastosProveedor: true,
      gastosEtiquetas: true,
      gastosMateriaPrima: true,

      ventasNegocios: true,
      ventasComensales: true,
      facturasSimplificadas: true,
      facturasNominativas: true,
      infoformasPago: true,
      infoagencias: true,
      cuentasAparcadas: true,
      cierreCaja: true,
      ventasZonaHoraria: true,
      cuentasAnuladas: true,
      ventasClientes: true,
      ventasOperarios: true,
      turnosOperarios: true,

      //PERMISOS CARTA
      gestionPedidos: true,
      productosCarta: true,
      categoriasCarta: true,
      formasPagoCarta: true,
      negocioCarta: true,
      carta: true,
      configuracionCarta: true,

      amorino: false,
      //Retail
      soloRetail: true,
      //Integraciones
      integracion: false,
      //Log
      log: false,
      esSelfi: false,
    };
  },
  computed: {
    soloTurnos() {
      return this.$store.state.soloTurnos;
    },

    isExternalLink() {
      // Devuelve true si estás en la ruta del enlace externo
      return this.$route.name === "turnos-operarios-external-link";
    },

    verifactuStatus() {

      // Volveremos a mostrar el modal y pedir los certificados a mitades del año 2026
      const fechaLimite = new Date('2026-06-01T00:00:00');
      const ahora = new Date();

      if (ahora < fechaLimite) {
        return 'aplazado';
      }

      const businesses = this.$store.state.xlistBusiness || [];

      let haExpirado = false;
      let expiraPronto = false;
      let sinConfigurar = false;

      businesses.forEach(business => {
        if (business.statusVerifactu === 'expirado') {
          haExpirado = true;
        } else if (business.statusVerifactu === 'expira_pronto') {
          expiraPronto = true;
        } else if (business.statusVerifactu === 'sin_configurar') {
          sinConfigurar = true;
        }
      });

      if (haExpirado) return 'expirado';
      if (expiraPronto) return 'expira_pronto';
      if (sinConfigurar) return 'sin_configurar';
      return 'ok';
    },
  },

  watch: {
    '$store.state.xlistBusiness': {
      handler(newBusinessList) {
        if (NIVEL_MOLESTIA_MODAL_VERIFACTU === 0) {
          return;
        }

        if (newBusinessList && newBusinessList.length > 0) {
          // Si nivel es 1, solo mostrar una vez
          if (NIVEL_MOLESTIA_MODAL_VERIFACTU === 1 && this.modalVerifactuMostrado) {
            return;
          }
          this.verificarVerifactuSinConfigurar(newBusinessList);
        }
      },
      deep: true,
      immediate: true
    },

    // Re-evaluar modal en cambios de ruta
    '$route'(to, from) {

      if (NIVEL_MOLESTIA_MODAL_VERIFACTU === 0) {
        return;
      }

      // Cancelar timeout pendiente si existe
      if (this.timeoutModalVerifactu) {
        clearTimeout(this.timeoutModalVerifactu);
        this.timeoutModalVerifactu = null;
      }

      // Re-evaluar y mostrar en nivel 2
      if (NIVEL_MOLESTIA_MODAL_VERIFACTU === 2) {
        this.$nextTick(() => {
          const businesses = this.$store.state.xlistBusiness || [];
          if (businesses.length > 0) {
            this.verificarVerifactuSinConfigurar(businesses);
          }
        });
      }
    }
  },
  methods: {
    checkIsSelfi() {
      let vm = this;

      const esSelfiCookie = document.cookie
        .split("; ")
        .find((row) => row.startsWith("esSelfi="));

      // Verificar si la cookie existe antes de intentar acceder a su valor
      if (esSelfiCookie) {
        vm.esSelfi = esSelfiCookie.split("=")[1];
      } else {
        vm.esSelfi = false;
      }
    },

    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },

    getConfigIntegracion() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idConfig: 117,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getConfigByUser", config)
        .then(function(response) {
          if (response.data.result) {
            vm.integracion = true;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    restrictions() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/getRestrictionsByUser",
          config
        )
        .then(function(response) {
          if (response.data.response) {
            for (let i = 0; i < response.data.result.length; i++) {
              switch (response.data.result[i].idRestriction) {
                case "73":
                  vm.log = true;
                  break;
                case "72":
                  vm.integracion = true;
                  // console.log(vm.integraciones);
                  break;
                case 1:
                  vm.cajaOnline = false;
                  break;
                case 52:
                  vm.camaras = false;
                  break;
                case 23:
                  vm.ventasProductos = false;
                  break;
                case 24:
                  vm.ventasTotalProductos = false;
                  break;
                case 25:
                  vm.invitaciones = false;
                  break;
                case 26:
                  vm.ventasCategorias = false;
                  break;
                case 27:
                  vm.costeProductos = false;
                  break;
                case 45:
                  vm.historicoProductos = false;
                  break;
                case 28:
                  vm.gastosCasas = false;
                  break;
                case 29:
                  vm.gastosCasa = false;
                  break;
                case 30:
                  vm.gastosProveedoresUnidos = false;
                  break;
                case 31:
                  vm.gastosProveedor = false;
                  break;
                case 32:
                  vm.gastosEtiquetas = false;
                  break;
                case 33:
                  vm.gastosMateriaPrima = false;
                  break;
                case 34:
                  vm.ventasNegocios = false;
                  break;
                case 35:
                  vm.ventasComensales = false;
                  break;
                case 36:
                  vm.facturasSimplificadas = false;
                  break;
                case 37:
                  vm.facturasNominativas = false;
                  break;
                case 38:
                  vm.infoformasPago = false;
                  break;
                case 39:
                  vm.infoagencias = false;
                  break;
                case 40:
                  vm.cuentasAparcadas = false;
                  break;
                case 41:
                  vm.cierreCaja = false;
                  break;
                case 48:
                  vm.ventasZonaHoraria = false;
                  break;
                case 47:
                  vm.cuentasAnuladas = false;
                  break;
                case 42:
                  vm.ventasClientes = false;
                  break;
                case 43:
                  vm.ventasOperarios = false;
                  break;
                case 44:
                  vm.turnosOperarios = false;
                  break;

                case 21:
                  vm.almacen = false;
                  break;

                case 22:
                  vm.pedidosProveedor = false;
                  break;

                case 50:
                  vm.posicionGlobal = false;
                  break;

                case 9:
                  vm.materiaPrima = false;
                  break;

                case 10:
                  vm.proveedores = false;
                  break;

                case 11:
                  vm.etiquetas = false;
                  break;
                case 12:
                  vm.productos = false;
                  break;
                case 13:
                  vm.categorias = false;
                  break;
                case 14:
                  vm.modificadores = false;
                  break;
                case 15:
                  vm.clientes = false;
                  break;
                case 16:
                  vm.casas = false;
                  break;
                case 17:
                  vm.operarios = false;
                  break;
                case 18:
                  vm.agencias = false;
                  break;
                case 19:
                  vm.formasPago = false;
                  break;
                case 49:
                  vm.configuracionAlmacen = false;
                  break;
                case 51:
                  vm.rangosHorarios = false;
                  break;
                case 20:
                  vm.gastos = false;
                  break;

                //PERMISOS CARTA

                case 59:
                  vm.gestionPedidos = false;
                  break;
                case 60:
                  vm.productosCarta = false;
                  break;
                case 61:
                  vm.categoriasCarta = false;
                  break;
                case 62:
                  vm.formasPagoCarta = false;
                  break;
                case 63:
                  vm.negocioCarta = false;
                  break;
                case 64:
                  vm.amorino = true;
                  break;
                case 70:
                  vm.gestionDePersonal = false;
                  break;
              }
            }

            if (
              !vm.materiaPrima &&
              !vm.proveedores &&
              !vm.etiquetas &&
              !vm.productos &&
              !vm.categorias &&
              !vm.modificadores &&
              !vm.clientes &&
              !vm.casas &&
              !vm.operarios &&
              !vm.agencias &&
              !vm.formasPago &&
              !vm.configuracionAlmacen &&
              !vm.rangosHorarios
            ) {
              vm.configuracion = false;
            }

            if (
              !vm.ventasProductos &&
              !vm.ventasTotalProductos &&
              !vm.invitaciones &&
              !vm.ventasCategorias &&
              !vm.costeProductos &&
              !vm.historicoProductos &&
              !vm.gastosCasas &&
              !vm.gastosCasa &&
              !vm.gastosProveedoresUnidos &&
              !vm.gastosProveedor &&
              !vm.gastosEtiquetas &&
              !vm.gastosMateriaPrima &&
              !vm.ventasNegocios &&
              !vm.ventasComensales &&
              !vm.facturasSimplificadas &&
              !vm.facturasNominativas &&
              !vm.infoformasPago &&
              !vm.infoagencias &&
              !vm.cuentasAparcadas &&
              !vm.cierreCaja &&
              !vm.ventasZonaHoraria &&
              !vm.cuentasAnuladas &&
              !vm.ventasClientes &&
              !vm.ventasOperarios &&
              !vm.turnosOperarios
            ) {
              vm.informes = false;
            }

            if (
              !vm.gestionPedidos &&
              !vm.productosCarta &&
              !vm.categoriasCarta &&
              !vm.formasPagoCarta &&
              !vm.negocioCarta
            ) {
              vm.carta = false;
            }

            if (
              !vm.productosCarta &&
              !vm.categoriasCarta &&
              !vm.formasPagoCarta &&
              !vm.negocioCarta
            ) {
              vm.configuracionCarta = false;
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    //SI NO TIENE CAMARAS OCULTAMOS LA PESTAÑA
    getCamaras() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getCamaras", config)
        .then(function(response) {
          if (!response.data.response) {
            vm.camaras = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    //PARA EJECUTAR
    checkGestionPersonal() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          //1 es gestión de personal
          idLicencia: 1,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/checkLicenciaProducto",
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.negocioGestionDePersonal = response.data.result;
          } else {
            console.error("Ha ocurrido un error al comprobar las licencias");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    restrictionCal() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getUser", config)
        .then(function(response) {
          if (response.data.response) {
            vm.registrosHorarios = true;
          } else {
            vm.registrosHorarios = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getConfigTpvRetail() {
      //Necesita IdBusiness
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 84,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
        .then(function(response) {
          if (response.data.response) {
            vm.soloRetail = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    verificarVerifactuSinConfigurar(businesses) {

      if (!businesses || businesses.length === 0) {
        return;
      }

      // DEBUG
      if (this.forceMostrarModalVerifactu) {
        if (this.timeoutModalVerifactu) {
          clearTimeout(this.timeoutModalVerifactu);
          this.timeoutModalVerifactu = null;
        }
        this.mostrarModalVerifactu = true;
        return;
      }

      const rutaActual = this.$route.path.replace(/\/$/, '');

      const rutasPrincipales = [
        '/cajas-online',
        '/informes',
        '/pedidos-proveedor',
        '/gestion-gastos',
        '/almacen',
        '/configuracion',
        '/posicion-global',
        '/calendar',
        '/soporte-online',
        '/configuracion-carta',
        '/delivery',
        '/importacion',
        '/integraciones',
        '/log'
      ];

      // Rutas donde no queremos que salga
      const esPrincipal = rutasPrincipales.some(ruta => rutaActual === ruta);
      const esRutaVerifactu = rutaActual.includes('/verifactu');

      if (esRutaVerifactu || !esPrincipal) {
        return;
      }

      // Verificar si hay al menos un negocio con statusVerifactu = 'sin_configurar'
      const tieneNegocioSinConfigurar = businesses.some(
        business => business.statusVerifactu === 'sin_configurar'
      );

      if (tieneNegocioSinConfigurar) {
        // Limpiar timeout
        if (this.timeoutModalVerifactu) {
          clearTimeout(this.timeoutModalVerifactu);
        }

        // En nivel 1, marcar como mostrado
        if (NIVEL_MOLESTIA_MODAL_VERIFACTU === 1) {
          this.modalVerifactuMostrado = true;
        }

        this.verificarEstadoModalVerifactu();
      }
    },

    async verificarEstadoModalVerifactu() {
      try {
        const jwtData = this.parseJwt(this.$store.getters.jwt);
        const idUser = jwtData ? jwtData.idUser : null;

        if (!idUser) {
          console.error('No se pudo obtener el idUser del JWT');
          return;
        }

        const config = {
          params: {
            jwt: this.$store.getters.jwt,
            idUser: idUser
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        const response = await this.axios.get(
          this.$store.getters.apiUrl + "users/getVerifactuModalStatus",
          config
        );

        if (response.data.status === 'success' && response.data.data.verifactuModalSeen === 0) {
          this.timeoutModalVerifactu = setTimeout(() => {
            this.mostrarModalVerifactu = true;
            this.timeoutModalVerifactu = null;
          }, 2000);
        }
      } catch (error) {
        console.error('Error al verificar estado del modal Verifactu:', error);
        this.timeoutModalVerifactu = setTimeout(() => {
          this.mostrarModalVerifactu = true;
          this.timeoutModalVerifactu = null;
        }, 2000);
      }
    },

    cerrarModal() {
      this.mostrarModalVerifactu = false;
    },

    async noVolverAMostrarModalVerifactu() {
      try {

        const jwtData = this.parseJwt(this.$store.getters.jwt);
        const idUser = jwtData ? jwtData.idUser : null;

        if (!idUser) {
          console.error('No se pudo obtener el idUser del JWT');
          return;
        }

        const config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        const response = await this.axios.post(
          this.$store.getters.apiUrl + "users/stopShowingVerifactuModal",
          {
            idUser: idUser
          },
          config
        );

        if (response.data.status === 'success' || response.data.response) {
          this.$notifications.notify({
            message: this.$t('preferenciasGuardadas') || 'Preferencias guardadas correctamente',
            icon: 'fa fa-check',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: 'success'
          });

          this.cerrarModal();

          this.modalVerifactuMostrado = true;
        } else {
          throw new Error(response.data.message || 'Error al guardar preferencias');
        }
      } catch (error) {
        console.error('Error al guardar preferencia de modal Verifactu:', error);

        this.$notifications.notify({
          message: this.$t('errorAlGuardarPreferencias') || 'Error al guardar las preferencias',
          icon: 'fa fa-exclamation-triangle',
          horizontalAlign: 'right',
          verticalAlign: 'top',
          type: 'danger'
        });
      }
    },

    parseJwt(token) {
      try {
        return JSON.parse(atob(token.split(".")[1]));
      } catch (e) {
        return null;
      }
    },

  },
};
</script>

<style lang="scss">

.vue-notifyjs.notifications {
  .list-move {
    transition: transform 0.3s, opacity 0.4s;
  }

  .list-item {
    display: inline-block;
    margin-right: 10px;
  }

  .list-enter-active {
    transition: transform 0.2s ease-in, opacity 0.4s ease-in;
  }

  .list-leave-active {
    transition: transform 1s ease-out, opacity 0.4s ease-out;
  }

  .list-enter {
    opacity: 0;
    transform: scale(1.1);
  }

  .list-leave-to {
    opacity: 0;
    transform: scale(1.2, 0.7);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Layout/DashboardLayout.vue